import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import classnames from 'classnames';
import Input from 'react-toolbox/lib/input';
import styles from './ThemedInput.css';

const ThemedInput = ({
  primary = false,
  accent = false,
  counter = false,
  className,
  ...rest
}) => {
  const inputClass = classnames(styles.themedInput, className, {
    [styles.hideCounter]: !counter,
    [styles.primary]: primary,
    [styles.neutral]: !primary && !accent,
    [styles.accent]: accent,
  });
  return <Input theme={styles} {...rest} className={inputClass} />;
};

ThemedInput.propTypes = {
  accent: PropTypes.bool,
  className: PropTypes.string,
  counter: PropTypes.bool,
  primary: PropTypes.bool,
};

export const CustomInput = glamorous(ThemedInput)({}, props => {
  const colorProp = props['data-iconColor'];
  if (colorProp) {
    return {
      '& span:first-of-type': {
        color: `${colorProp} !important`,
      },
    };
  }
  return {};
});

export default ThemedInput;



// WEBPACK FOOTER //
// ./src/common/components/ThemedInput/index.js